"use client";

import type { JsonInputType } from "@tosize/shapes/src/lib/models/Input/JsonInputType";
import { type Dispatch, type SetStateAction, createContext, useContext } from "react";
import type { ZodErrorMap, ZodIssue } from "zod";

export type FieldErrorType = Record<string, ZodIssue[]>;
export type KeyOfErrorsType = keyof ErrorsType;
export interface ErrorsType {
	product: ZodIssue[];
	shape: ZodIssue[];
	dimensions: FieldErrorType;
	accepted_condition: ZodIssue[];
}

export type TouchedFieldsType = Record<KeyOfErrorsType, JsonInputType[]>;

interface ErrorContextValue {
	hasErrors: boolean;
	errorMap: ZodErrorMap;
	errors: ErrorsType;
	setErrors: Dispatch<SetStateAction<ErrorsType>>;
	resetErrors: (field: KeyOfErrorsType) => void;
	addErrors: (field: KeyOfErrorsType, errors: FieldErrorType) => void;

	touchedFields: TouchedFieldsType;
	setTouchedFields: Dispatch<SetStateAction<TouchedFieldsType>>;
}

export const ErrorContext = createContext<ErrorContextValue>({} as ErrorContextValue);

export function useErrorContext() {
	const context = useContext(ErrorContext);

	if (context === null) throw new Error("ErrorContext is not available");

	return context;
}
